module.exports = __webpack_public_path__ + "images/help/logo-small-6ccbefe12d31496876eb6a30e7ab02b3.png";